import { getStore } from '../store/childStore';
import { mutatorAction } from 'satcheljs';
import { PopoutChildState } from '../store/schema/PopoutChildStore';
import { postMessage, PopoutMessageType } from '../utils/crossWindowMessenger';

const setPopoutChildStateMutator: (state: PopoutChildState) => void = mutatorAction(
    'setPopoutChildState',
    (state: PopoutChildState): void => {
        const store = getStore();
        store.state = state;

        if (state == PopoutChildState.Ready && store.isPopoutV2 && window.opener) {
            postMessage(window.opener, PopoutMessageType.DeeplinkReady, undefined);
        }
    }
);
export default setPopoutChildStateMutator;
